import segment from 'src/js/modules/analytics/segment';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackElementSettingsToggleClicked = ({
  blockId,
  blockVariationId,
  settingId,
  tabId,
  elementType,
  controlId,
  isActive,
}) => {
  if (!blockId || !controlId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_SECTION_TOGGLE_CLICKED, {
    blockId,
    blockVariationId,
    settingId,
    tabId,
    elementId: elementType,
    optionId: controlId,
    isActive,
  });
};

export default trackElementSettingsToggleClicked;
